import { fetcher } from "helpers/fetcher";

import {
  TGetOrganizationFacilityReq,
  TGetOrganizationFacilityRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getOrganizationFacility = async (
  params?: TGetOrganizationFacilityReq
) => {
  return await fetcher<
    TGetOrganizationFacilityRes,
    TGetOrganizationFacilityReq["data"]
  >(ENDPOINT.CORPORATION.GET_ORGANIZATION_FACILITY, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_ORGANIZATION_FACILITY.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetOrganizationFacility = async (
  params?: TGetOrganizationFacilityReq
) => {
  return (await getOrganizationFacility(params)).data;
};

queryGetOrganizationFacility._key = (
  params?: TGetOrganizationFacilityReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_ORGANIZATION_FACILITY.url, params, key];
